if (!customElements.get('form-search-model')) {
  class ComponentFormSearchModel extends HTMLElement {
    constructor() {
      super();
      this.searchForm = this.querySelector('.search-parts-form');
      this.searchField = this.searchForm.querySelector('input[name="model"]');
      this.searchMessage = this.searchForm.querySelector('.message');
      
      this.searchForm.addEventListener('submit', this.doSearch.bind(this));
    }

    doSearch(e) {
      e.preventDefault();
      e.stopPropagation();

      this.searchMessage.innerHTML = '';

      var term = this.searchField.value;
      var modelUrl = this.searchForm.action + $s.handleize(term);

      fetch(modelUrl)
        .then(response => {
          if (!response.ok) {
            if (response.status === 404) {
              throw new Error('Resource not found (404)');
            } else {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
          }
          return response.text();
        })
        .then(data => {
          window.location.href = modelUrl;
        })
        .catch(error => {
          this.searchMessage.innerHTML = 'Model not found';
        });
    }
  }
  customElements.define('form-search-model', ComponentFormSearchModel);
}
